import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Kavindu Nimsara',
    title: "Programmer",
    desciption:"He was quiet, but not in the way people usually are. His silence felt full, like it carried meaning. There was something steady in the way he moved, something certain in his eyes. It felt like he had already faced the storm, and now he was just waiting for the rest to catch up.",
    image: 'https://avatars.githubusercontent.com/u/81173459?v=4',
    resumePdf: '#'
}
